/** Маркер в sessionStorage: пользователь явно открыл новый пустой проект (кнопки на лендинге / ЛК / меню). */
export const NEW_PROJECT_ONBOARDING_INTENT_KEY = 'welland_new_project_onboarding_intent';

/**
 * Запомнить намерение показать обучалку (переживает монтирование /app после navigate).
 */
export function markNewProjectOnboardingIntent() {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.sessionStorage.setItem(NEW_PROJECT_ONBOARDING_INTENT_KEY, '1');
  } catch {
    /* sessionStorage недоступен */
  }
}

/**
 * @returns {boolean}
 */
export function peekNewProjectOnboardingIntent() {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    return window.sessionStorage.getItem(NEW_PROJECT_ONBOARDING_INTENT_KEY) === '1';
  } catch {
    return false;
  }
}

/**
 * Сбросить маркер после показа приветствия или закрытия тура.
 */
export function clearNewProjectOnboardingIntent() {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.sessionStorage.removeItem(NEW_PROJECT_ONBOARDING_INTENT_KEY);
  } catch {
    /* ignore */
  }
}
